import { Route } from '@angular/router';
import { authGuard, developmentGuard, loginGuard } from '@dental-ui/auth';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('@dental-ui/login').then(m => m.LoginComponent),
  },
  {
    path: 'forget-password',
    canActivate: [loginGuard],
    loadComponent: () => import('@dental-ui/forget-password').then(m => m.ForgetPasswordComponent),
  },
  {
    path: 'passwordChange',
    canActivate: [loginGuard],
    loadComponent: () => import('@dental-ui/password-change').then(m => m.PasswordChangeComponent),
  },
  {
    path: 'register',
    canActivate: [loginGuard],
    loadComponent: () => import('@dental-ui/register').then(m => m.RegisterComponent),
  },
  {
    path: 'userActivation',
    loadComponent: () => import('@dental-ui/user-activation').then(m => m.UserActivationComponent),
  },
  {
    path: 'invitedEmail',
    loadComponent: () => import('@dental-ui/branch-invite-accept').then(m => m.BranchInviteAcceptComponent),
  },
  {
    path: 'profile',
    canActivate: [authGuard, developmentGuard],
    loadComponent: () => import('@dental-ui/profile').then(m => m.ProfileComponent),
  },

  {
    path: 'account',
    canActivate: [authGuard],
    loadComponent: () => import('@dental-ui/account').then(m => m.AccountComponent),
  },
  {
    path: 'account/services',
    canActivate: [authGuard, developmentGuard],
    loadComponent: () => import('@dental-ui/clinical-service').then(m => m.ClinicalServiceListComponent),
  },
  {
    path: 'account/prices',
    canActivate: [authGuard, developmentGuard],
    loadComponent: () => import('@dental-ui/clinical-service').then(m => m.PricesPageComponent),
  },
  {
    path: 'account/subscriptions',
    canActivate: [authGuard],
    loadComponent: () => import('@dental-ui/subscriptions').then(m => m.SubscriptionsComponent),
  },
  {
    path: 'account/organization',
    canActivate: [authGuard],
    loadComponent: () => import('@dental-ui/organization').then(m => m.OrganizationComponent),
  },
  {
    path: 'account/team',
    canActivate: [authGuard],
    loadComponent: () => import('@dental-ui/users').then(m => m.UsersComponent),
  },
  {
    path: 'account/partners',
    canActivate: [authGuard, developmentGuard],
    loadComponent: () => import('@dental-ui/partners').then(m => m.PartnersComponent),
  },
  {
    path: 'account/settings',
    canActivate: [authGuard],
    loadComponent: () => import('@dental-ui/settings').then(m => m.SettingsComponent),
  },
  {
    path: 'account/forms',
    canActivate: [authGuard, developmentGuard],
    loadChildren: () => import('@dental-ui/forms').then(m => m.formsRoutes),
  },
  {
    path: 'account/communication',
    canActivate: [authGuard, developmentGuard],
    canDeactivate: [
      (component: { confirmLeave: () => boolean | import('rxjs').Observable<boolean> }) =>
        component.confirmLeave(),
    ],
    loadComponent: () => import('@dental-ui/communication').then(m => m.CommunicationComponent),
  },
];
